<template>
  <v-app-bar app style="background-color: #f8f9fb">
    <v-toolbar-title
      style="cursor: pointer"
      @click="$router.push('/')"
      class="headline text-uppercase d-flex align-center"
    >
      <img
        src="../../public/colorCom.png"
        alt="大材库"
        title="大材库-优秀的化学搜索网站"
        style="width: 175px; height: 60px"
      />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <!-- FIXME: 注释时间：2021-10-09 同日更改：logo替换、公司名称修改 -->
    <!-- <div style="margin-right: 60px;" class="common-font-color">
      <router-link style="text-decoration: none; color: #3f57bb;" to="/author">
        {{ $i18n.t("Packages and prices") }}
      </router-link>
    </div> -->
    <div style="margin-right: 120px" class="common-font-color">
      <a
        href="http://www.mgbig.com/"
        target="_blank"
        style="text-decoration: none; color: #3f57bb"
      >
        {{ $i18n.t("About") }}
      </a>
    </div>

    <div
      style="margin-right: 45px"
      class="common-font-color"
      @click="changeLanguage"
    >
      {{ $i18n.t(language) }}
    </div>
    <div
      v-if="isSignIn"
      class="d-flex justify-space-around align-center"
      style="height: 64px; width: 150px"
    >
      <div
        @click="toPersonal"
        class="common-font-color"
        style="min-width: 130px; color: #3f57bb; text-align: center"
      >
        {{ $i18n.t("personal_center") }}
      </div>
      <div
        @click="logOut"
        style="margin-left: 10px; margin-right: 50px; cursor: pointer"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="#3f58bb" style="transform: rotate(-90deg)"
              >mdi-location-exit</v-icon
            >
          </template>
          <span
            style="
              display: inline-block !important;
              text-align: center;
              min-width: 60px;
            "
          >
            {{ $i18n.t("sign_out") }}
          </span>
        </v-tooltip>
      </div>
    </div>
    <div
      v-else
      class="d-flex justify-space-around align-center"
      style="height: 100%; width: 100px"
    >
      <div class="common-font-color" style="min-width: 60px" @click="showLogin">
        {{ $i18n.t("sign_in") }}
      </div>
      <div
        class="common-font-color"
        style="min-width: 60px"
        @click="showRegister"
      >
        {{ $i18n.t("sign_up") }}
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Topbar",
  data() {
    return {
      language: "English",
      token: "",
    };
  },

  computed: {
    ...mapState(["isSignIn"]),
  },
  methods: {
    ...mapMutations(["SET_SHOW_SIGNIN", "SET_SHOW_SIGNUP", "SET_SIGN_IN"]),
    ...mapActions(["signOut"]),
    showLogin: function () {
      this.SET_SHOW_SIGNIN(true);
    },
    showRegister() {
      this.SET_SHOW_SIGNUP(true);
    },
    toPersonal() {
      this.$router.push("/personal_center");
    },
    logOut() {
      this.signOut();
      this.$router.push("/");
    },
    changeLanguage() {
      if (this.$i18n.locale === "en") {
        this.language = "English";
        window.localStorage.setItem("language", JSON.stringify("zh-CN"));
        this.$i18n.locale = "zh-CN";
      } else {
        this.language = "Chinese";
        window.localStorage.setItem("language", JSON.stringify("en"));
        this.$i18n.locale = "en";
      }
    },
  },
  mounted() {
    let language = JSON.parse(window.localStorage.getItem("language"));
    if (language === "en") {
      this.language = "Chinese";
      this.$i18n.locale = "en";
    } else {
      this.language = "English";
      this.$i18n.locale = "zh-CN";
    }
  },
};
</script>

<style lang="scss">
.v-toolbar__content {
  height: 64px !important;
}

.v-app-bar {
  min-height: 64px !important;
  min-width: 700px !important;
  box-shadow: 0 0 1px -1px rgba(0, 0, 0, 0.1),
    0px 1px 0px 0px rgba(0, 0, 0, 0.1), 0px 1px 10px 0px rgba(0, 0, 0, 0.1) !important;
}
</style>
